<template>
  <div class="app-container editForm">
    <div class="detailHead">
      <div class="title">
        <img src="@/assets/images/accident/location.png" alt=""/>
        <span
          style="
            color: #9098a3;
            font-size: 16px;
            vertical-align: top;
            margin-left: 5px;
          "
        >理赔管理 > 诊疗资料</span
        >
      </div>
      <div class="btnGroup">
        <button class="back" @click="() => $router.push('/index')">
          <img src="@/assets/images/accident/back.png"/>返回
        </button>
      </div>

      <div class="titleContent" style="margin-top: 15px; color: #d8dce5">
        <span>事故编号: {{ this.accident.thirdAccidentId }}</span>
        <span style="margin-left: 20px">报警电话： {{ this.accident.reportPhone }} </span>
        <span>事故时间/地点: {{ this.accident.accidentTime }} &nbsp; {{ this.accident.accidentAddress }}</span>
      </div>
    </div>
    <div class="accident-edit">
      <!-- 表格 -->
      <el-table
        :data="patientList"
        v-on="$listeners"
        v-bind="$attrs"
        row-key="id"
        v-loading="loading"
        :highlight-current-row="false"
        :header-cell-style="{background: 'rgba(2, 133, 216, 0.1)', color: '#7CAFFF', fontWeight: 100}"
      >
        <el-table-column class-name="orderNumber" type="index" label="序号"></el-table-column>
        <el-table-column
          label="资料名称"
          width="280"
        >
          <template slot-scope="scope">
            <span class="tablecell">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="姓名"
          width="180"
        >
          <template slot-scope="scope">
            <span class="tablecell">{{ scope.row.xm }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="身份证号"
          width="280"
        >
          <template slot-scope="scope">
            <span class="tablecell">{{ scope.row.sfzh }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="资料上传时间"
          width="280"
        >
          <template slot-scope="scope">
            <span class="tablecell">{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <el-link
              class="linkstyle"
              v-if="currentRole === '保险员'"
              @click="openCallModal(scope.row)"
            >查看
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <myDialog :logTitle="'发票信息'" :logHeight="'640px'" :showDialog.sync="fpxxShow">
      <div class="closebtn">
        <el-button
          type="primary"
          @click="
            () => {
              fpxxShow = false;
            }
          "
        >关闭
        </el-button
        >
      </div>
      <div class="imgmodal" style="color: #d8dce5;margin-top: 15px">
        <div v-for="invoice in invoiceArr" style="margin-top: 21px">
        <span>发票号: {{ invoice.invoiceNo }}</span>
        <a :href="invoice.cosUrl" target="_blank" style="margin-left: 15px">点击查看</a>
      </div>
      </div>
    </myDialog>

    <myDialog :logTitle="'病例'" :logHeight="'640px'" :showDialog.sync="blShow" >
      <div class="closebtn">
        <el-button
          type="primary"
          @click="
            () => {
              blShow = false;
            }
          "
        >关闭
        </el-button
        >
      </div>
      <div class="imgmodal" style="background-color: #d8dce5">
        <div v-for="bl in blArr">
          <div>{{ bl.title }}</div>
          <div v-html="bl.fileContent">

          </div>
        </div>
      </div>
    </myDialog>

    <myDialog :logTitle="'费用明细'" :logHeight="'640px'" :showDialog.sync="fymxShow">
      <div class="closebtn">
        <el-button
          type="primary"
          @click="
            () => {
              fymxShow = false;
            }
          "
        >关闭
        </el-button
        >
      </div>
      <div class="imgmodal">

        <el-table :data="fymxArr">
          <el-table-column
            label="项目名称"
            width="180"
          >
            <template slot-scope="scope">
              <span class="tablecell">{{ scope.row.itemName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="数量"
            width="80"
          >
            <template slot-scope="scope">
              <span class="tablecell">{{ scope.row.qty }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="单位"
            width="80"
          >
            <template slot-scope="scope">
              <span class="tablecell">{{ scope.row.packUnit }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="规格"
            width="120"
          >
            <template slot-scope="scope">
              <span class="tablecell">{{ scope.row.specs }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="金额"
            width="80"
          >
            <template slot-scope="scope">
              <span class="tablecell">{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="金额合计"
            width="80"
          >
            <template slot-scope="scope">
              <span class="tablecell">{{ scope.row.cost }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div style="color: #d8dce5;margin-top: 10px; text-align: right">总费用 {{fymxInfo.fyzj}} 元</div>
      </div>
    </myDialog>
  </div>
</template>


<script>
// import Photos from "../accident/components/Photos";
// import insurancePhoto from "../accident/components/insurancePhoto";
// import BasicInfoForm from "../accident/components/BasicInfoForm";
// import OperationRecord from "../accident/components/OperationRecord";
// import VideoRecord from "../accident/components/VideoRecord";
// import StreamVideo from "../accident/components/StreamVideo";
// import AccidentPartys from "../accident/components/AccidentPartys";
import myDialog from '@/components/custom/myDialog.vue'

import {getAccident, saveAccident, cancellationAccident} from '@/api/accident/edit'
import {
  getPatientList,
  getPatientEmrInfo,
  getPatientFeeInfo,
  getPatientPacsInfo,
  getPatientLisInfo,
  getPatientInvoiceInfo
} from '@/api/patient/list'
import Liability from '../accident/components/Liability'
import Claim from '../accident/components/Claim'
import {getListRole} from '@/api/system/role'
// import UploadStatement from '../components/UploadStatement';
import SmsDialog from '@/views/accident/edit/sms-dialog'
import DictSelect from '../accident/components/dict-select.vue'
import {offlineProcessing} from '@/api/accident/upload'
import claimsSelect from '@/views/accident/components/claimsSelect'
import {get} from '@/utils/dict'
import detailStyle from '@/views/accident/components/detailStyle.vue'
import '../accident/common.less'
import pliceCascader from '@/views/accident/components/pliceCascader'
import axios from 'axios'
// import accidentData from '../components/a.json';
export default {
  name: 'patientIndex',
  components: {myDialog},

  provide() {
    return {
      targetRefs: this.$refs,
      isDisabled: this.isDisabled,
      accident: this.accident,
      checkList: () => this.checkList
    }
  },
  data() {
    return {
      loading: false,
      accident_status: [],
      activeParty: '0',
      smsDialogVisible: false,
      accident: {
        latitude: 0.0,
        longitude: 0.0,
        accidentType: '', // 报警类型
        directIndemnity: '', // 是否接受直赔
        accidentPhotoList: [],
        accidentPartyList: [],
        isInsurance: [], // 保险截图列表
        accidentTime: null,
        applicable: true,
        caseDealType: null,
        crashType: null,
        id: '',
        injuredCount: null,
        policeGroupId: null,
        remark: '',
        reportPhone: '',
        status: null,
        weather: null,
        participants: [],
        accidentAddress: '',
        statementUrl: '',
        isOverpass: '', // 是否高架
        objectDestroyed: '', // 是否物损
        objectName: '', // 物损名称
        policePhone: '', // 警员电话
        policeName: '', // 警员名称
        county: '', // 行政单位
        videoUrl: '', // 视频链接
        thirdAccidentId: null
      },
      videoArr: [], // 用来存储多个视频的链接
      selectdVideo: 0, // 控制视频按钮样式
      liabilityVisible: false,
      claimVisible: false,
      timeout: null,
      isDisabled: {value: false},
      checkList: ['1'], // 报警类型
      offlineId: '', // 线下处理交警id
      OfflineBrigadeId: '', //线下处理大队id
      carLicenseType: null,
      accidentTitle: '事故详情',
      OfflinePolice: '', // 线下处理交警id
      brigadeDis: false, // 是否禁用线下大队
      policeDis: false, // 是否禁用线下交警
      patient: [],
      patientList: [],
      blShow: false,
      fpxxShow: false,
      fymxShow: false,

      blArr: [],
      fymxArr: [],
      fymxInfo: {},
      lisArr: [],
      pacsArr: [],
      invoiceArr: [],
      thirdAccidentId: null
    }
  },
  computed: {
    currentRole() {
      return this.$store.getters.accidentRoleName
    },
    isAdd() {
      return this.$route.name === 'AccidentAdd'
    },
    isDisabledComputed() {
      if (this.isAdmin) {
        this.isDisabled.value = false
        return false
      }
      if (this.currentRole === '坐席') {
        const value = this.accident.status !== 0
        this.isDisabled.value = value
        return value
      } else {
        this.isDisabled.value = true
        return true
      }
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    },
    offlineList() {
      let list =
        this.$store.getters.selecaData.length &&
        this.$store.getters.selecaData.filter(el => {
          const arr =
            el.roles &&
            el.roles.filter(role => {
              return role.roleKey === 'OfflineBrigade'
            })
          return arr && arr.length
        })
      return list
    }
  },
  watch: {
    // 报警类型转数组
    'accident.accidentType': {
      handler(val) {
        if (val) {
          this.checkList = val.split(',')
        }
      },
      immediate: true,
      deep: true
    },
    'accident.accidentPartyList': {
      handler(val) {
        if (!val.length) {
          this.accident.accidentPartyList.push({
            partyDirectIndemnity: {accidentWoundedList: [{}]}
          })
        } else {
          this.accident.accidentPartyList.forEach(el => {
            if (!el.partyDirectIndemnity) {
              this.$set(el, 'partyDirectIndemnity', {
                accidentWoundedList: [{}]
              })
            }
          })
        }
      },
      immediate: true,
      deep: true
    },
    OfflineBrigadeId(val) {
      if (val) {
        console.log(111)
        this.policeDis = true
      } else {
        console.log(222)
        this.policeDis = false
      }
    },
    OfflinePolice(val) {
      if (val) {
        console.log(111)
        this.brigadeDis = true
      } else {
        console.log(222)
        this.brigadeDis = false
      }
    },
  },
  async created() {
    this.accident.id = this.$route.params.id
    this.accident.thirdAccidentId = this.$route.params.thirdAccidentId
    this.thirdAccidentId = this.$route.params.thirdAccidentId
    this.getAccident()
    this.getAccidentStatus()
    this.getPatient()
    this.carLicenseType = await get('car_license_type')
    if (this.$route.name === 'AccidentEdit') {
      this.accidentTitle = '事故详情'
    } else {
      this.accidentTitle = '新建事故'
    }
  },
  methods: {
    sendPhone() {
      axios.defaults.headers['Content-Type'] = 'application/json'
      let obj = {}
      obj.voiceTemplateId = 100
      obj.tenantId = 124
      obj.userId = 3
      obj.list = []
      obj.list.push({})
      obj.list[0]['calledNumber'] = '13657083265'
      obj.list[0]['calledUsername'] = '钟11'
      obj.list[0]['certificatesNumber'] = '320922199608115011'
      obj.list[0]['plateNo'] = '苏J03F21'
      obj.list[0]['accidentPlace'] = '江苏无锡盐都区大数据中心'
      obj.list[0]['accidentId'] = '202110260004'
      obj.list[0]['certificatesType'] = '1'
      axios.post('https://ycjjdd.aegis-info.com/api/third/callout', obj).then(res => {
        console.log(res)
      })
    },
    showSmsDialog() {
      this.smsDialogVisible = true
    },
    /**
     * 初始化数据，用于切换快处状态时
     */
    changeApplicable(value) {
      if (!value) {
        this.$confirm('事故将转线下处理！', '提示', {
          type: 'warning'
        }).then(() => {
          this.accident.applicable = value
        })
      } else {
        this.accident.applicable = value
      }
    },
    //判断打开类型
    openCallModal(row) {
      var value = row.value
      if (value == 'bl') {
        this.blShow = true
        getPatientEmrInfo({
          'accidentId': this.thirdAccidentId,
          'hospital': 'JDFY',
          'sfzh': row.sfzh,
          'xm': row.xm,
          'startTime': '2000-01-01',
          'endTime': '2099-01-01',
          'history': true
        }).then(res => {
          this.blArr = res.data.emrList
        })
      } else if (value == 'pacs') {

      } else if (value == 'fymx') {
        this.fymxShow = true
        getPatientFeeInfo({
          'accidentId': this.thirdAccidentId,
          'hospital': 'JDFY',
          'sfzh': row.sfzh,
          'xm': row.xm,
          'startTime': '2000-01-01',
          'endTime': '2099-01-01',
          'history': true
        }).then(res => {
          this.fymxInfo = res.data;
          this.fymxArr = res.data.feeList
        })

      } else if (value == 'lis') {

      } else if (value == 'invoice') {
        this.fpxxShow = true
        getPatientInvoiceInfo({
          'accidentId': this.thirdAccidentId,
          'hospital': 'JDFY',
          'sfzh': row.sfzh,
          'xm': row.xm,
          'startTime': '2000-01-01',
          'endTime': '2099-01-01',
          'history': true
        }).then(res => {
          this.invoiceArr = res.data.invoiceList
        })
      } else {

      }
    },
    /**
     * 获取当前事故
     */
    async getAccident() {
      const {data} = await getAccident(this.accident.id)
      this.videoArr = data.videoUrl && data.videoUrl.split(',')
      this.$nextTick(() => {
        if (this.$refs.operationRecord) {
          this.$refs.operationRecord.getLog()
        }
      })
      console.log('getAccident. data', data)
      Object.assign(this.accident, data)
      if (this.videoArr) {
        console.log(this.videoArr)
        this.accident.videoUrl = this.videoArr[this.videoArr.length - 1]
        this.selectdVideo = this.videoArr.length - 1
        console.log(this.accident)
        this.$store.commit('app/SET_ACTIVEINJURED', '0')
      }
      // this.accident = accidentData;
      return data
      // if (this.accident.status === 0) {
      //   clearTimeout(this.timeout);
      //   this.timingTemp();
      // }
    },

    getPatient() {
      console.info('accidentId ======', this.accident.id)
      getPatientList(this.accident.thirdAccidentId).then(data => {
        console.info('data ======== ', data)
        if (data && data.code == 200) {
          this.patient = data.data
          for (var i = 0; i < this.patient.length; i++) {
            var p = this.patient[i]
            if (p.bl == '1') {
              var p1 = {}
              Object.assign(p1, p)
              p1.name = '病例'
              p1.value = 'bl'
              this.patientList.push(p1)
            }
            if (p.pacs == '1') {
              var p2 = {}
              Object.assign(p2, p)
              p2.name = '影像片及诊断报告'
              p2.value = 'pacs'
              this.patientList.push(p2)
            }
            if (p.fymx == '1') {
              var p3 = {}
              Object.assign(p3, p)
              p3.name = '费用明细'
              p3.value = 'fymx'
              this.patientList.push(p3)
            }
            if (p.lis == '1') {
              var p4 = {}
              Object.assign(p4, p)
              p4.name = '检验结果'
              p4.value = 'lis'
              this.patientList.push(p4)
            }
            if (p.cyjl == '1') {
              var p5 = {}
              Object.assign(p5, p)
              p5.name = '出院记录'
              p5.value = 'cyjl'
              this.patientList.push(p5)
            }
            if (p.ssjl == '1') {
              var p6 = {}
              Object.assign(p6, p)
              p6.name = '手术记录'
              p6.value = 'ssjl'
              this.patientList.push(p6)
            }
            if (p.bacl == '1') {
              var p7 = {}
              Object.assign(p7, p)
              p7.name = '长期或临时医嘱单等病案材料'
              p7.value = 'bacl'
              this.patientList.push(p7)
            }
            if (p.invoice == '1') {
              var p8 = {}
              Object.assign(p8, p)
              p8.name = '发票信息'
              p8.value = 'invoice'
              this.patientList.push(p8)
            }

          }
        }
      })

    },
    /**
     * 获取状态字典
     */
    getAccidentStatus() {
      this.getDicts('accident_status').then(({data}) => {
        this.accident_status = data
      })
    },
    // 获取医院，拖修车角色
    getListRole() {
      getListRole().then(res => {
        if (res.code === 0 && res.data) {
          this.$store.commit('app/SET_SELECTDATA', res.data)
        }
      })
    },
    /**
     * 校验所有表单
     */
    validate() {
      let newArr = []
      if (this.$refs.accidentPartys) {
        const refArr = Object.values(
          this.$refs.accidentPartys.$refs.partyForm
        ).filter(ref => ref && ref.validate)
        if (this.checkList.includes('3')) {
          if (!this.accident.policePhone || !this.accident.policeName) {
            this.$message.error('请选择交警信息！')
            return
          }
          refArr.forEach(el => {
            if (el.$refs.injuredList) {
              newArr.push(
                ...el.$refs.injuredList.$refs.injuredForm
                  .filter(ref => ref && ref.validate)
                  .map(ref => ref.validate())
              )
            }
          })
        }
      }
      newArr.push(
        ...Object.values(this.$refs)
          .filter(ref => ref && ref.validate)
          .map(ref => ref.validate())
      )
      // console.log(newArr);
      return Promise.all(newArr)
    },
    getCleanData(data) {
      return Object.keys(data).reduce((acc, cur) => {
        let {[cur]: value} = data
        if (cur === 'accidentPartyList' || cur === 'accidentPhotoList') {
          value = value
            .map(item => this.getCleanData(item))
            .filter(item => Object.keys(item).length)
        }
        if (value || value === false || value === 0) {
          acc[cur] = value
        }
        return acc
      }, {})
    },
    /**
     * 定时暂存
     */
    // timingTemp() {
    //   this.timeout = setTimeout(() => {
    //     this.tempAccident(true);
    //   }, 10000);
    // },
  }
}
</script>
<style lang="scss">
.app-container {
  height: calc(100vh - 90px);
  overflow: auto;
  //background: url("../../../assets/images/list/bgc.png") no-repeat;
  //background-size: 100% 100%;
  &::-webkit-scrollbar {
    /*定义滚动条高宽及背景
    高宽分别对应横竖滚动条的尺寸*/
    width: 0px;
    background-color: #f5f5f5;
  }

  .detailHead {
    position: fixed;
    top: 110px;
    left: 20px;
    width: 100%;
    height: 140px;
    z-index: 99;

    .title {
      margin-bottom: 20px;
    }

    .btnGroup {
      button {
        width: 160px;
        height: 48px;
        background: rgba(0, 132, 255, 0.1);
        border-radius: 4px;
        border: 1px solid #0084ff;
        color: #b1e3ff;
        font-size: 20px;
        letter-spacing: 1px;
        margin-right: 20px;
        cursor: pointer;

        img {
          margin-right: 10px;
        }
      }

      .back {
        background: rgba(255, 125, 0, 0.1);
        border: 1px solid #ff7d00;
      }

      .submit {
        background: rgba(14, 189, 53, 0.1);
        border: 1px solid #0ebd35;
      }

      .isDisabled {
        cursor: not-allowed;
      }
    }
  }

  .accident-edit {
    margin-top: 130px;
    padding-top: 15px;
    position: relative;
    display: flex;

    .el-form--inline {
      .el-form-item {
        width: 300px;
      }
    }

    // .left-content,
    // .right-content {
    //   height: 100%;
    //   margin-top: 0;
    //   overflow: auto;
    //   & > * {
    //     margin-bottom: 15px;
    //   }
    // }

    .left-content {
      width: 800px;
      position: sticky;
      top: 190px;
      display: flex;
      flex-direction: column;
      overflow: initial;
      // position: relative;
      .videolists {
        position: absolute;
        color: white;
        top: 30px;
        left: 41px;
        z-index: 100;
        display: flex;

        .changvideobtn {
          padding: 4px 10px;
          border: 1px solid #0084FF;
          background: rgba(0, 132, 255, 0.1);
          color: #B1E3FF;
          margin-left: 10px;
          cursor: pointer;
          border-radius: 4px;
        }

        .videoselected {
          background: rgba(14, 189, 53, 0.1);
          border-radius: 4px;
          border: 1px solid #0EBD35;
          color: #0EBD35;
        }
      }

      .scroll-wrapper {
        width: 1000px;
        height: 450px;
        flex: 1;
        overflow: scroll;

        &::-webkit-scrollbar {
          width: 0;
        }
      }

      .video-record,
      .stream-video {
        .header {
          width: 100%;
          display: flex;
          align-items: center;

          .header-operator-group {
            flex: 1;
            text-align: right;
            font-weight: 400;
            color: #020202;
            line-height: 17px;
            font-size: 14px;

            .info {
              cursor: pointer;

              .icon {
                color: #004dbe;
              }
            }

            :not(:last-child) {
              margin-right: 20px;
            }
          }
        }
      }
    }

    .right-content {
      flex: 1;
      width: 1000px;
      height: 700px;
      padding-top: 15px;
      margin: -15px 0 0 40px;
      overflow-x: hidden;
      overflow-y: auto;

      &::-webkit-scrollbar {
        /*定义滚动条高宽及背景
        高宽分别对应横竖滚动条的尺寸*/
        width: 6px;
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        display: block;
        width: 6px;
        margin: 0 auto;
        border-radius: 10px;
        background: #eee;
      }

      .scroll-wrapper {
        width: 1000px;
      }

      .baseInfo {
        width: 1000px;
        margin-top: 54px;

        .baseInfo-content {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          padding: 55px 80px;
        }

        .accident-info {
          // display: flex;
          // justify-content: space-between;
          font-weight: 500;
          width: 100%;
          color: #020202;

          .accident-number {
            margin: 0;
            font-size: 22px;
            line-height: 28px;
          }
        }

        .accident-status {
          width: 300px;
          font-size: 16px;
          line-height: inherit;
          color: #b1e3ff;

          img {
            vertical-align: middle;
          }

          span {
            margin-right: 15px;
          }
        }

        .applicable {
          box-shadow: 0px 2px 18px 8px rgba(0, 0, 0, 0.05);
          border-radius: 8px;
          height: 110px;
          background: #fff;
          display: flex;
          align-items: center;
          padding: 0 40px;
          font-size: 18px;
          color: #020202;
        }

        .statement {
          cursor: pointer;
          justify-content: center;
          color: #909399;
          height: 200px;
          width: 150px;
          display: flex;
          align-items: center;
          flex-direction: column;
          background: rgba(0, 0, 0, 0.04);
        }

        .operator-group {
          position: fixed;
          top: 95px;
          right: 30px;
          background-color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 999;
        }

        .alarmType {
          font-size: 16px;
          margin-bottom: 40px;
          // display: flex;
          // align-items: center;
          & > span {
            font-weight: 600;
            color: #606266;
          }
        }

        .isDispose {
          width: 100%;
          margin-bottom: 60px;

          .notApplicable {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .el-form-item {
              width: 300px;
            }

            .offline {
              width: 300px;
              height: 48px;
              margin-top: 15px;
              line-height: 48px;
              text-align: center;
              background: rgba(14, 189, 53, 0.1);
              border-radius: 4px;
              cursor: pointer;
              font-size: 18px;
              letter-spacing: 1px;
              color: #0ebd35;
              border: 1px solid #0ebd35;
            }
          }
        }
      }

      .accidentPartys {
        width: 1000px;
        margin-top: 50px;
        background: rgba(15, 31, 70, 0.6);
      }

      .operation {
        width: 1000px;
        height: 510px;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;

        .operationRecord {
          padding: 45px 20px;
          width: 500px;
          height: 510px;
        }

        .accdientRemark {
          width: 460px;
          height: 510px;
          margin-left: 40px;
          padding: 45px 20px;
          position: relative;

          .el-textarea__inner {
            width: 420px;
            height: 424px;
          }
        }
      }
    }
  }
}

.person-list {
  list-style: none;
  padding: 0;
  margin: 0;

  .role {
    line-height: 20px;

    .role-name {
      font-size: 14px;
    }

    .member-list {
      padding: 0 0 0 13px;
      margin: 0;
      list-style: none;
      font-size: 14px;
      color: #020202;

      .member {
        line-height: 20px;
      }
    }
  }
}
</style>
